var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.222069mm",
    height: "78.221886mm",
    viewBox: "0 0 78.222069 78.221886",
    id: "svg854",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-57.81699,-118.90192)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.0538721
    },
    d: "m 84.183385,181.47873 c -1.832324,-0.36954 -3.27251,-1.69774 -3.651345,-3.36744 -0.06265,-0.27609 -0.07579,-3.77124 -0.07579,-20.14565 v -19.81162 l 0.127403,-0.435 c 0.399858,-1.36525 1.435989,-2.4357 2.857684,-2.95235 0.837384,-0.30431 0.130552,-0.29006 13.645858,-0.27515 l 12.395565,0.0136 0.49738,0.14196 c 0.83354,0.23791 1.33841,0.50619 1.95164,1.03711 0.60871,0.52699 1.11562,1.32452 1.34115,2.11002 0.0991,0.34491 0.10411,1.16253 0.12195,19.83731 0.0131,13.62645 3.2e-4,19.64196 -0.0421,20.02485 -0.12555,1.13262 -0.57689,1.96493 -1.49394,2.75491 -0.52791,0.45476 -1.17343,0.79433 -1.89836,0.9986 l -0.42134,0.11873 -12.508513,0.01 c -10.227771,0.007 -12.570286,-0.003 -12.847336,-0.0592 z M 108.63568,158.01702 V 143.03626 H 96.917782 85.199878 l -0.01446,14.92938 c -0.008,8.21116 -0.0023,14.95833 0.0124,14.99373 0.02142,0.0514 2.397599,0.0617 11.73236,0.0514 l 11.705502,-0.013 z",
    id: "path3591"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 96.928024,
    cy: 158.01286,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.264583
    },
    id: "path3045",
    d: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.264583
    },
    id: "path2908",
    d: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.bf9f1a5aef3d937b43b639c72f2d4554.svg";
export { ForwardRef as ReactComponent };